angular.module('lf.desktop')

.directive('miniCartHighlightRecentlyAddedItem', function () {
  return function (scope, el, attrs) {
    var delayTimeoutId = null;
    var scrollToBottomInterval = null;

    scope.$on('cart:add', function () {
      var $el = $(el);

      clearTimeout(delayTimeoutId);
      clearInterval(scrollToBottomInterval);
      scrollToBottom();
      
      delayTimeoutId = setTimeout(function () {
        scrollToBottomInterval = setInterval(scrollToBottom, 200);
        scrollToBottom();
        
        el.find('.mCSB_container ul > li.mini-cart__item:last')
          .css('border-color', '#ffc300')
          .velocity({
            borderColorAlpha: 0
          }, {
            delay: 1000,
            duration: 1000,
            complete: function () {
              clearInterval(scrollToBottomInterval);
            }
          });
      }, 50);
      
      function scrollToBottom () {
        $el.mCustomScrollbar('update')
        $el.mCustomScrollbar('scrollTo', 'bottom', {scrollInertia: 0});
      }
    });
    
    scope.$on('$destroy', function () {
      clearTimeout(delayTimeoutId);
      clearInterval(scrollToBottomInterval);
    });
  }
});
